import React, { useState, useEffect } from "react";
import GoujianCard from "./GoujianCard";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import CategoryTabs from "./CategoryTabs";
import { Router, Link } from "@reach/router";
import Divider from "@material-ui/core/Divider";
import { withSnackbar } from "notistack";
import store from "../../../../reduxstore";
import { SelectFilterBar, FilterBar } from "../detailpage";
import SERVER_ADDRESS from "../../../../config";
import ReactLoading from "react-loading";
import { useTestState } from "../../../../ilabx-grade-return";

const useStyles = makeStyles(theme => ({
  grid: {
    flexGrow: 1
  },
  categorybar: {
    padding: theme.spacing(4)
  },
  divider: {
    width: "100%",
    height: 1
  },
  loader: {
    margin: "auto"
  }
}));

//过滤方法
const objectArrayFilter = (objectArray, filterValue) => {
  const filterFields = Object.keys(filterValue);
  let objectFiltered = [...objectArray];
  for (let index = 0; index < filterFields.length; index++) {
    const filterField = filterFields[index];

    //category以外使用indexOf匹配
    if (
      filterField !== "category" &&
      filterValue[filterField] !== "" &&
      objectFiltered.length > 0
    ) {
      objectFiltered = objectFiltered.filter(object => {
        return object[filterField].indexOf(filterValue[filterField]) !== -1;
      });
    }
    //category=使用精确匹配

    if (
      filterField === "category" &&
      filterValue[filterField] !== "" &&
      objectFiltered.length > 0
    ) {
      objectFiltered = objectFiltered.filter(object => {
        return object[filterField] === filterValue[filterField];
      });
    }
  }
  return objectFiltered;
};

function checkFilterStatus(filterObject) {
  //包含过滤内容的字段
  const filteredFields = Object.keys(filterObject).filter(filterField => {
    return !(filterObject[filterField] === "");
  });
  return filteredFields.length !== 0;
}
//使用构件过滤
function useFilter(initValue) {
  const [filterValue, setFilterValue] = useState(initValue);

  const handleChange = name => event => {
    setFilterValue({ ...filterValue, [name]: event.target.value });
  };

  return { filterValue, handleChange };
}

//获取构件信息
function useGoujians(initValue, enqueueSnackbar) {
  const [goujians, setGoujians] = useState(initValue);
  useEffect(() => {
    fetch(`${SERVER_ADDRESS}/api/goujians.json/`, {
      headers: {
        Accept: "application/json, text/plain, */*"
      },
      mode: "cors",
      credentials: "include"
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText);
        }
        return res.json();
      })
      .then(data => {
        //close dialog after finish post
        setGoujians(data);
        //成功后的反馈SnackBar
        // enqueueSnackbar("网络畅通", {
        //   variant: "success"
        // });
      })
      .catch(error => {
        //失败后显示错误SnackBar
        // console.log(error);
        enqueueSnackbar("无法连接服务器，请检查网络", {
          variant: "error"
        });
      });

    return () => {
      setGoujians(initValue);
    };
  }, []);

  //freshData
  const freshData = (data, method = "update") => {
    if (method === "update") {
      setGoujians((prevGoujians, props) => {
        const newGoujians = [];
        prevGoujians.forEach(goujian => {
          newGoujians.push(goujian.id === data.id ? data : goujian);
        });
        return newGoujians;
      });
    }
  };
  return { goujians, freshData };
}

//Main Component
function GoujianList(props) {
  const classes = useStyles();
  const { categoryOptions } = store.getState();

  const { filterValue, handleChange } = useFilter({
    name: "",
    description: "",
    category: ""
  });

  //初始渲染构件个数
  const { initRenderNumber } = props;
  const [showAll, setShowAll] = useState(false);

  const { goujians, freshData } = useGoujians([], props.enqueueSnackbar);

  //ilabx update test state
  useTestState();

  //实际会渲染的构件, 如果已显示全部，或构件在过滤中则不使用slice功能
  let goujianToRender =
    showAll || checkFilterStatus(filterValue)
      ? objectArrayFilter(goujians, filterValue)
      : goujians.slice(0, initRenderNumber);

  return (
    <Grid container className={classes.grid} spacing={2}>
      <Grid
        container
        item
        xs={12}
        className={classes.categorybar}
        justify="flex-end"
      >
        <Grid item>
          <FilterBar
            value={filterValue.name}
            handleChange={handleChange("name")}
            label="过滤构件名称"
          />
        </Grid>
        <Hidden xsDown>
          <Grid item>
            <FilterBar
              value={filterValue.description}
              handleChange={handleChange("description")}
              label="过滤构件描述"
            />
          </Grid>
        </Hidden>
        <Hidden xsDown>
          <Grid item>
            <SelectFilterBar
              categoryOptions={categoryOptions}
              value={filterValue.category}
              handleChange={handleChange("category")}
              label="过滤构件类型"
              minWidth="200px"
            />
          </Grid>
        </Hidden>
      </Grid>
      <Divider className={classes.divider} />

      {goujians.length === 0 ? (
        <ReactLoading type="bars" color="#117BEA" className={classes.loader} />
      ) : (
        <>
          {goujianToRender.map(goujian => (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={goujian.id}>
              <GoujianCard goujian={goujian} freshData={freshData} />
            </Grid>
          ))}
          <Grid
            container
            item
            xs={12}
            className={classes.categorybar}
            justify="center"
          >
            {showAll || checkFilterStatus(filterValue) ? null : (
              <Button
                color="primary"
                variant="text"
                onClick={() => {
                  setShowAll(true);
                }}
              >
                显示全部构件
              </Button>
            )}
          </Grid>
        </>
      )}
    </Grid>
  );
}

export default withSnackbar(GoujianList);
